// src/pages/Terms.tsx
import { SeoHead } from '@/components/SeoHead';
import { LegalPageLayout } from '@/components/LegalPageLayout';
import { useLanguage } from '@/hooks/useLanguage';
import { localePath } from '@/i18n/paths';
import { termsOfService } from '@/lib/legal-content';

const seoContent = {
  pl: {
    title: 'Regulamin | Bookeper AI',
    description:
      'Regulamin korzystania z Bookeper AI. Poznaj zasady i warunki korzystania z naszej usługi.',
  },
  en: {
    title: 'Terms of Service | Bookeper AI',
    description:
      'Bookeper AI Terms of Service. Learn about the rules and conditions for using our service.',
  },
  uk: {
    title: 'Умови Використання | Bookeper AI',
    description:
      'Умови використання Bookeper AI. Ознайомтеся з правилами та умовами користування нашим сервісом.',
  },
} as const;

export default function Terms() {
  const lang = useLanguage();
  const seo = seoContent[lang];

  return (
    <>
      <SeoHead>
        <html lang={lang} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={`https://www.bookeper.pl${localePath('/terms', lang)}`} />
      </SeoHead>
      <LegalPageLayout document={termsOfService[lang]} />
    </>
  );
}
